<template>
  <div class="difficultDegree" style="display: block;" v-if="difficultDegree">
    <div
      class="difficultDegree__dialog"
      style="width: 750px; height: undefinedpx;"
      role="document"
    >
      <div class="difficultDegree__content">
        <div class="difficultDegree__header">
          <button type="button" class="difficultDegree__header--close" @click="closeSelf">
            <span>×</span>
          </button>
          <h4 class="difficultDegree__title">难度推荐</h4>
        </div>
        <div class="difficultDegree__body">
          <div class="difficultDegree__innerbox">
            <h2>我们为您推荐的课程难度为：</h2>
            <div class="difficultDegree__recommend">
              <h3>{{ currentSubject }}<span>推荐</span></h3>
              <p>{{ difficultDegree.difficulty_name + difficultDegree.version_name }}</p>
            </div>
            <div class="difficultDegree__recommend difficultDegree__recommend02">
              <h4>{{ difficultDegree.abstruct_name }}</h4>
              <pre>{{ difficultDegree.abstruct }}</pre>
            </div>
          </div>
          <div class="difficultDegree__footer">
            <div class="difficultDegree__footer__gobox">
              <a
                class="difficultDegree__footer__btn02"
                v-if="difficultDegree.need_exam === 1"
                :href="difficultDegree.exam_url"
                @click="linkClick($event)"
                >立即参加考试</a
              >
              <div class="difficultDegree__footer__btn" @click="closeDegree($event)">
                立即选课
              </div>
            </div>
            <p>
              <img src="//res13.xesimg.com/x5mall/img/tanhao.png" alt="" />注：点击
              <span>立即选课</span>
              后跳转到该难度课程列表，您只要再选择合适的上课时间就搞定了
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      difficultDegree: state => state.CourseCenter.difficultDegree,
      subjectName: state => state.subjectName,
      subjectNameZh: state => state.subjectNameZh
      // ,
      // subjectEnum: state => state.subjectEnum
    }),
    currentSubject() {
      const { subject } = this.$route.params
      return this.subjectNameZh[subject]
    }
  },
  methods: {
    closeDegree(event) {
      // this.$store.state.showDifficultDegree = false
      // this.$store.state.difficultId = this.difficultDegree.difficultyId
      this.$store.commit('SET_SHOWDEGREETIP', true)
      this.$store.commit('SET_SHOWDIFFICULTDEGREE', false)
      // this.$emit('updataDifficultId', this.difficultDegree.difficulty_id, event)
      const { subject = 0, grade } = this.$route.params
      // 直接跳搜索页
      window.location.href = `https://online.xueersi.com/search?keyword=${this.difficultDegree.difficulty_name}&grades=${grade}&subjects=${subject}`
      const xesLog = new this.$XESLog({
        key: 'xeslog-lijixuanke-courseCenter',
        clickid: '1.2.21',
        subjectid: Number(subject),
        gradeid: Number(grade)
      })
      xesLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
    closeSelf() {
      this.$store.commit('SET_SHOWDIFFICULTDEGREE', false)
    },
    linkClick(event) {
      const { subject = 0, grade } = this.$route.params
      const XESLog = new this.$XESLog({
        key: 'xeslog-examinationnow-www',
        clickid: '1.2.22',
        clickurl: this.difficultDegree.exam_url,
        subjectid: Number(subject),
        gradeid: Number(grade)
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(difficultDegree) {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  @include e(dialog) {
    width: 750px;
    position: absolute;
    margin: 10px auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
  @include e(content) {
    position: relative;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    background-clip: padding-box;
    outline: 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
  @include e(header) {
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
    min-height: 16.42857143px;
    box-sizing: border-box;
    @include m(close) {
      margin-top: -2px;
      padding: 0;
      cursor: pointer;
      background: transparent;
      border: 0;
      float: right;
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: 0.2;
    }
  }
  @include e(title) {
    margin: 0;
    line-height: 1.42857143;
  }
  @include e(body) {
    padding: 0 45px 28px 45px;
    position: relative;
  }
  @include e(innerbox) {
    min-height: 360px;
    margin-top: 30px;
  }
  @include e(recommend) {
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 10px;
    width: 335px;
    box-sizing: border-box;
    border: 2px solid #f13232;
    padding: 25px 12px;
  }
  @include e(recommend02) {
    border: 2px solid #d2d2d2;
  }
  @include e(footer) {
    width: 100%;
    text-align: center;
    margin-top: 50px;
    position: relative;
    @include e(gobox) {
      width: 335px;
      margin: 0 auto;
      &::after {
        content: '';
        display: block;
        clear: both;
      }
    }
    @include e(btn) {
      display: inline-block;
      padding: 0 30px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #f13232;
      border: 1px solid #f13232;
      color: #fff;
      border-radius: 2px;
      font-size: 16px;
      margin-bottom: 30px;
    }
    @include e(btn02) {
      border: 1px solid #f13232;
      background: #fff;
      color: #f13232;
      float: left;
      width: 140px;
      padding: 0;
      display: inline-block;
      text-align: center;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      font-size: 16px;
      margin-bottom: 30px;
    }
  }
}
.difficultDegree__innerbox h2 {
  font-size: 16px;
  margin-bottom: 30px;
  margin-top: 0;
}
.difficultDegree__recommend h3 {
  color: #333;
  font-size: 16px;
  margin: 0 0 13px 0;
  position: relative;
}
.difficultDegree__recommend h3 span {
  position: absolute;
  right: 0;
  top: -4px;
  padding: 4px 8px;
  background: #f0773c;
  border-radius: 5px 0 5px 0;
  color: #ffffff;
}
.difficultDegree__recommend p {
  color: #f13232;
  font-size: 16px;
  margin: 0;
}
.difficultDegree__recommend02 h4 {
  color: #666;
  font-size: 14px;
  margin: 0 0 13px 0;
}
.difficultDegree__recommend02 pre {
  font-size: 14px;
  line-height: 20px;
  border: none;
  padding: 0;
  margin: 0;
  border-radius: 0;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.difficultDegree__footer p {
  font-size: 13px;
}
.difficultDegree__footer p img {
  width: 16px;
  height: 16px;
  position: relative;
  top: -2px;
  margin-right: 5px;
  vertical-align: middle;
}
.difficultDegree__footer p span {
  color: #f13232;
}
</style>



// WEBPACK FOOTER //
// ./src/components/DifficultDegree.vue